import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

// Import assets
import './slider.scss';
import '../../../../assets/icons/Lenspire_Icon_ArrowSlider.svg';


const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`m-nav-slider__next-arrow ${className}`} onClick={onClick} tabIndex={-1} role={'button'}>
      <div className={'m-nav-slider__arrow-wrapper'}>
        <svg>
          <use xlinkHref="#Lenspire_Icon_ArrowSlider" />
        </svg>
        <svg>
          <use xlinkHref="#Lenspire_Icon_ArrowSlider" />
        </svg>
      </div>
    </div>
  );
};

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

NextArrow.defaultProps = {
  className: '',
  onClick: () => {
  },
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`m-nav-slider__prev-arrow ${className}`} onClick={onClick} tabIndex={-1} role={'button'}>
      <div className={'m-nav-slider__arrow-wrapper'}>
        <svg>
          <use xlinkHref="#Lenspire_Icon_ArrowSlider" />
        </svg>
        <svg>
          <use xlinkHref="#Lenspire_Icon_ArrowSlider" />
        </svg>
      </div>
    </div>
  );
};

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

PrevArrow.defaultProps = {
  className: '',
  onClick: () => {
  },
};

const defaultSliderSettings = {
  accessibility: true,
  variableWidth: false,
  centerMode: false,
  infinite: true,
  focusOnSelect: true,
  vertical: false,
  initialSlide: 0,
  arrows: true,
  adaptiveHeight: false,
  swipeToSlide: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

class SliderView extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.forceRerender) {
      setTimeout(() => {
        this.forceUpdate();
      }, 10);
    }
  }

  render() {
    if (this.props.children.length > 1) {
      return (
        <Slider {...defaultSliderSettings} {...this.props.sliderSettings} ref={(slider) => { this.slider = slider; }} className={`m-slider ${this.props.className}`}>
          {this.props.children}
        </Slider>
      );
    }
    return (
      <div className={`m-slider ${this.props.className}`} ref={(slider) => { this.slider = slider; }}>
        {this.props.children}
      </div>
    );
  }
}

SliderView.propTypes = {
  children: PropTypes.node,
  sliderSettings: PropTypes.shape(),
  className: PropTypes.string,
  forceRerender: PropTypes.bool,
};

SliderView.defaultProps = {
  children: null,
  sliderSettings: {
    accessibility: true,
    variableWidth: true,
    centerMode: false,
    infinite: false,
    vertical: false,
    initialSlide: 0,
    centerPadding: 0,
    arrows: true,
    adaptiveHeight: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  },
  className: '',
  forceRerender: false,
};

export default SliderView;




// WEBPACK FOOTER //
// ./frontend/js/Components/Util/Slider/SliderView.jsx